<div class="flex h-[400px]">
  <mat-card appearance="filled" class="m-auto w-1/2 flex flex-col">
    <mat-card-header>
      <h3 class="font-medium tracking-tight text-md" matCardTitle>Connexion</h3>
    </mat-card-header>
    <mat-card-content class="flex flex-auto flex-col overflow-hidden p-4 gap-2">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Identifiant</mat-label>
          <input matInput [(ngModel)]="identifiant" name="identifiant">
          <mat-icon matSuffix>perm_identity</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Mot de passe</mat-label>
          <input matInput [(ngModel)]="motDePasse" name="motDePasse" type="password">
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
      </div>

      <mat-checkbox class="example-margin" [(ngModel)]="resterConnecte" color="primary">Rester connecter</mat-checkbox>
      <button mat-raised-button color="primary" class="float-right" (click)="login()">Connexion</button>
    </mat-card-content>
  </mat-card>
</div>

<div class="flex">
  <div class="m-auto">
    {{version}}
  </div>
</div>
